import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { ControlledCheckbox, ControlledTextField } from 'components/shared';
import CLASelect from 'components/shared/CLASelect/CLASelect';
import ValidityFormElement from 'components/shared/CRUD/components/ValidityFormElement';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { EmployerFields } from './components/EmployerFields';

const GeneralSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.general'
  });

  return (
    <MultiStepForm.Section title={t('title')}>
      <Grid container spacing={2}>
        <EmployerFields />
        <Grid item xs={12}>
          <CLASelect />
        </Grid>
        <Grid item xs={12}>
          <ControlledCheckbox
            control={control}
            label={t('default_label')}
            name="flags.DEFAULT"
          />
        </Grid>
        <Grid item xs={12}>
          <ValidityFormElement />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            variant="outlined"
            name="codeExt"
            label={t('external_code_label')}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            variant="outlined"
            name="exportgroupCode"
            label={t('export_group_label')}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            variant="outlined"
            name="invoiceGroup"
            label={t('invoice_group_label')}
          />
        </Grid>
      </Grid>
    </MultiStepForm.Section>
  );
};
export default GeneralSection;
